<template>
  <template v-if="pageList == 'orderdatarecord'">
    <!-- APP資料調整 -->
    <orderDataRecord></orderDataRecord>
  </template>
  <template v-else-if="pageList == 'manualrecord'">
    <!-- 人工處理紀錄 -->
    <manualRecord></manualRecord>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import orderDataRecord from "@/components/orderManagement/orderDataRecord";
import manualRecord from "@/components/orderManagement/manualRecord";
export default {
  components: {
    orderDataRecord,
    manualRecord,
  },
  setup() {
    const store = useStore();

    //getters
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );

    const pageList = ref();
    const pageListChild = ref();

    //function
    const setSessionItems = () => {
      sessionStorage.setItem("mes-deviceManagement-pageList", pageList.value);
      sessionStorage.setItem(
        "mes-deviceManagement-pageListChild",
        pageListChild.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    watch(sideBarSelect, (newValue) => {
      pageList.value = newValue.pageList;
      pageListChild.value = newValue.pageListChild;
    });

    setTimeout(() => {
      pageList.value = sideBarSelect.value.pageList;
      pageListChild.value = sideBarSelect.value.pageListChild;

      //session資料
      const mesDeviceManagementPageList = sessionStorage.getItem(
        "mes-deviceManagement-pageList"
      );
      const mesDeviceManagementPageListChild = sessionStorage.getItem(
        "mes-deviceManagement-pageListChild"
      );
      sessionStorage.removeItem("mes-deviceManagement-pageList");
      sessionStorage.removeItem("mes-deviceManagement-pageListChild");
      if (mesDeviceManagementPageList != null) {
        pageList.value = mesDeviceManagementPageList;
      }
      if (mesDeviceManagementPageListChild != null) {
        pageListChild.value = mesDeviceManagementPageListChild;
      }
    }, 0);

    provide("pageList", pageList);
    provide("pageListChild", pageListChild);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });

    return { pageList };
  },
};
</script>

<style></style>
<style lang="scss">
.orderManagement-table-button {
  height: 21px;
  line-height: normal;
  line-height: 13px;
  background-color: #4b8c80;
  border-color: #4b8c80;
  color: #fff;
  font-size: 14px;
}
.orderManagement-table-button:hover {
  color: #fff;
}
</style>
